import CenteredContent from '@cohort/wallet/components/layout/CenteredContent';
import AboutNftTransferPanel from '@cohort/wallet/components/space/AboutNftTransferPanel';
import {NftTransferLogin} from '@cohort/wallet/components/space/nftTransfer/NftTransferLogin';
import {useTransferInvitationContext} from '@cohort/wallet/hooks/useTransferInvitationContext';
import SpacePage from '@cohort/wallet/layouts/space/SpacePage';
import {getNftTransferInvitationRoute} from '@cohort/wallet/lib/Pages';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

const DigitalAssetTransferInvitationLoginPage: React.FC = () => {
  const {t} = useTranslation('pages', {keyPrefix: 'space.nftTransferInvitationPage'});
  const invitation = useTransferInvitationContext();
  const navigate = useNavigate();

  return (
    <SpacePage
      title={t('pageTitle')}
      tracking={{
        namespace: 'digitalAssets.transfer',
        metadata: {
          invitationId: invitation.id,
        },
      }}
      leftPanel={
        <AboutNftTransferPanel transferCtaEnabled={false} nftTransferInvitation={invitation} />
      }
    >
      <div className="h-full">
        <CenteredContent className="max-w-xl">
          <NftTransferLogin
            recipientEmail={invitation.recipientEmail}
            onSuccessLogin={() =>
              navigate(getNftTransferInvitationRoute(invitation.id), {
                replace: true,
                state: {fromLogin: true},
              })
            }
          />
        </CenteredContent>
      </div>
    </SpacePage>
  );
};

export default DigitalAssetTransferInvitationLoginPage;
